export default function IconLinkChain({ className }: { className?: string }) {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="-0.57 -0.57 16 16" id="Link-Chain--Streamline-Flex" height="16" width="16" className={className}>
			<desc>Link Chain Streamline Icon: https://streamlinehq.com</desc>
			<g id="link-chain--create-hyperlink-link-make-unlink-connection-chain">
				<path
					id="Vector"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M9.402134285714286 5.458927142857142 5.458927142857142 9.401072857142855"
					strokeWidth="1.14"
				></path>
				<path
					id="Vector 2470"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M8.740864285714284 12.039784285714285c-2.4975414285714286 2.2003414285714284 -4.813578571428572 3.2840599999999998 -7.0086128571428565 1.0879642857142855 -2.17699 -2.175928571428571 -1.1304214285714285 -4.470737142857143 1.0317085714285714 -6.943865714285714"
					strokeWidth="1.14"
				></path>
				<path
					id="Vector 2471"
					stroke="currentColor"
					strokeLinecap="round"
					strokeLinejoin="round"
					d="M6.120197142857142 2.8202157142857143C8.616677142857142 0.6198742857142856 10.932714285714287 -0.4638442857142857 13.12881 1.7322514285714283c2.175928571428571 2.175928571428571 1.12936 4.470737142857143 -1.03277 6.943865714285714"
					strokeWidth="1.14"
				></path>
			</g>
		</svg>
	);
}
